import React from 'react';
import { motion } from 'framer-motion';
export function Section7() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-gray-50 py-16" data-id="element-168">
      <div className="max-w-3xl mx-auto px-6" data-id="element-169">
        <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-4" data-id="element-170">
          7. What Skeptics Are Saying
        </h2>
        <p className="font-sans text-xl text-[#666666] mb-12" data-id="element-171">
          Over 50,000 pet parents are now using FLO. Here's what the ones who
          were most skeptical have to say.
        </p>

        <div className="space-y-8" data-id="element-172">
          <div className="bg-white p-8 rounded shadow-md border-l-4 border-[#4DC61A]" data-id="element-173">
            <div className="flex items-start gap-4 mb-4" data-id="element-174">
              <img src="https://placehold.co/80x80/4DC61A/ffffff?text=JM" alt="Customer photo" className="rounded-full" data-id="element-175" />
              <div data-id="element-176">
                <p className="font-sans font-bold text-lg text-[#0F4226]" data-id="element-177">
                  Jennifer M.
                </p>
                <p className="text-sm text-[#666666]" data-id="element-178">
                  Golden Retriever owner, Vermont
                </p>
              </div>
            </div>
            <p className="font-sans text-lg leading-relaxed text-[#666666] mb-4" data-id="element-179">
              "I tried every natural spray on Amazon. Every single one. We live
              in tick country and I was finding 3-4 ticks on Bella after every
              walk. I was so skeptical of FLO — another pendant that would
              probably stop working in two weeks. But I was desperate. It's been
              8 months. Not one tick.{' '}
              <strong className="text-[#0F4226]" data-id="element-180">
                Do you know how long I've been looking for that feeling?
              </strong>
              "
            </p>
            <p className="text-sm text-[#666666] italic" data-id="element-181">
              Previously tried: Wondercide, Vet's Best, homemade peppermint
              spray
            </p>
          </div>

          <div className="bg-white p-8 rounded shadow-md border-l-4 border-[#4DC61A]" data-id="element-182">
            <div className="flex items-start gap-4 mb-4" data-id="element-183">
              <img src="https://placehold.co/80x80/4DC61A/ffffff?text=RL" alt="Customer photo" className="rounded-full" data-id="element-184" />
              <div data-id="element-185">
                <p className="font-sans font-bold text-lg text-[#0F4226]" data-id="element-186">
                  Rachel L.
                </p>
                <p className="text-sm text-[#666666]" data-id="element-187">
                  Cat owner (2 cats), Portland, OR
                </p>
              </div>
            </div>
            <p className="font-sans text-lg leading-relaxed text-[#666666] mb-4" data-id="element-188">
              "I was terrified to try anything with essential oils on my cats
              after reading about toxicity. But FLO's airborne delivery made
              sense to me — it's not topical, they're not ingesting it. My
              indoor-outdoor cats haven't had a single flea in 6 months. I check
              them obsessively. Nothing. I finally stopped holding my breath
              every time they come inside."
            </p>
            <p className="text-sm text-[#666666] italic" data-id="element-189">
              Previously tried: Nothing — too scared of harming cats with
              natural products
            </p>
          </div>

          <div className="bg-white p-8 rounded shadow-md border-l-4 border-[#4DC61A]" data-id="element-190">
            <div className="flex items-start gap-4 mb-4" data-id="element-191">
              <img src="https://placehold.co/80x80/4DC61A/ffffff?text=DK" alt="Customer photo" className="rounded-full" data-id="element-192" />
              <div data-id="element-193">
                <p className="font-sans font-bold text-lg text-[#0F4226]" data-id="element-194">
                  David K.
                </p>
                <p className="text-sm text-[#666666]" data-id="element-195">
                  Labrador owner, Connecticut
                </p>
              </div>
            </div>
            <p className="font-sans text-lg leading-relaxed text-[#666666] mb-4" data-id="element-196">
              "We're in Lyme disease central. I used Bravecto for years because
              I was convinced nothing natural could handle the tick pressure
              here. Then my dog had a seizure. The vet said it 'probably wasn't'
              the Bravecto. I didn't believe him. Switched to FLO last April. We
              hike 4-5 times a week. I've found exactly two ticks on him all
              season — both crawling on his fur, neither attached. That never
              happened with Bravecto."
            </p>
            <p className="text-sm text-[#666666] italic" data-id="element-197">
              Previously used: Bravecto (oral), then tried natural collar that
              failed
            </p>
          </div>

          <div className="bg-white p-8 rounded shadow-md border-l-4 border-[#4DC61A]" data-id="element-198">
            <div className="flex items-start gap-4 mb-4" data-id="element-199">
              <img src="https://placehold.co/80x80/4DC61A/ffffff?text=SM" alt="Customer photo with dog" className="rounded-full" data-id="element-200" />
              <div data-id="element-201">
                <p className="font-sans font-bold text-lg text-[#0F4226]" data-id="element-202">
                  Sarah M.
                </p>
                <p className="text-sm text-[#666666]" data-id="element-203">
                  Beagle owner, North Carolina
                </p>
              </div>
            </div>
            <p className="font-sans text-lg leading-relaxed text-[#666666] mb-4" data-id="element-204">
              "I'm a research scientist. I read the studies. I understood the
              mechanism. I still didn't think it would work as well as it does.
              My beagle is a tick magnet — low to the ground, loves the woods.
              Last year with Seresto I was still pulling off 1-2 ticks a week.
              This year with FLO? Zero. Literally zero. I keep waiting for it to
              stop working. It hasn't."
            </p>
            <p className="text-sm text-[#666666] italic" data-id="element-205">
              Previously used: Seresto collar, Frontline Plus
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-206">
          <p className="font-sans text-3xl italic text-[#0F4226] leading-relaxed font-medium" data-id="element-207">
            "Do you know how long I've been looking for that feeling?"
          </p>
        </div>
      </div>
    </motion.section>;
}